var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aulas-agendadas-not-found"},[_c('div',{class:['aulas-agendadas-empty-warning', { center: _vm.center }]},[_c('img',{attrs:{"src":require("assets/warning.svg"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }